import type { MetricsResponse, StatsResponse } from "@cdt/shared";

import { api } from "@/lib/api";

export async function fetchStats(): Promise<StatsResponse> {
  return api.get<StatsResponse>("/api/stats");
}

export async function fetchMetrics(days = 30): Promise<MetricsResponse> {
  return api.get<MetricsResponse>(`/api/metrics?days=${days}`);
}
